export default __webpack_public_path__ + "static/media/check-box-outline-blank-24-px.462b50a8.svg";